import remember from "../utils/remember.js";
import GamePiece from "./game-piece.js";

export default class GamePieceAssassin extends GamePiece {

    constructor(...args) {
        super(...args);
        this.isAssassin = true;
    }

    getJumpedPieceByDirection = direction => remember(this, `__jumpedPieceByDirection<${direction}>`, () => {
        const nextNonBlankPiece = this.getNextNonEmptyPieceByDirection(direction);
        return nextNonBlankPiece?.getNextNonEmptyPieceByDirection(direction);
    });

    getPieceToAttackByDirection = direction => remember(this, `__getPieceToAttackByDirection<${direction}>`, () => {
        return this.getJumpedPieceByDirection(direction);
    });

    canAttackByDirection = direction => remember(this, `__canAttackByDirection<${direction}>`, () => {
        const {
            teamIndex,
        } = this;
        const pieceToAttack = this.getPieceToAttackByDirection(direction);

        if (!pieceToAttack) return false;
        if (pieceToAttack.isEmpty) return false;
        if (pieceToAttack.isUnturned) return false;
        if (teamIndex === pieceToAttack.teamIndex) return false;

        // assassin can attack any piece after jumping
        return true;
    });
}
